import { Empty } from 'antd';
Empty.defaultProps = {
  image: Empty.PRESENTED_IMAGE_SIMPLE
};
export default Empty;